import React from 'react';

const Banner = () => {
  return (
    <div className="relative flex overflow-hidden items-center bg-[#fcc76d] h-20 w-full mt-32">
      <div className="absolute animate-marquee whitespace-nowrap">
        <span className="text-[22px] sm:text-[22px] font-medium mx-4 text-white">
          Welcome to the temple...
        </span>
        <button className='px-5 py-2 bg-[#f3af38] text-white rounded-full'>
          Learn more
        </button>
      </div>
    </div>
  );
};

export default Banner;
